import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function TermsPage() {
  return (
    <div className="bg-grain min-h-screen" data-testid="terms-page">
      <Header />
      <main className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <span className="pill">Legal</span>
          <h1 className="mt-5 font-display font-black text-white text-4xl md:text-5xl tracking-tighter">
            Terms of Service
          </h1>
          <p className="mt-4 text-[#A0AABF] text-sm">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <div className="mt-8 snap-card border-orange-500/30">
            <p className="font-accent text-xs text-orange-400">PLEASE READ BEFORE YOU PAY</p>
            <ul className="mt-3 space-y-2 text-white">
              <li className="flex gap-3"><span className="text-[#3B9EFF]">•</span> Once payment is received, you are entitled to <span className="font-bold">one (1) revision</span> on your delivered content.</li>
              <li className="flex gap-3"><span className="text-[#3B9EFF]">•</span> <span className="font-bold">All sales are final. No refunds will be issued</span> under any circumstances.</li>
              <li className="flex gap-3"><span className="text-[#3B9EFF]">•</span> By completing checkout you confirm that you have read and accepted these terms.</li>
            </ul>
          </div>

          <div className="mt-8 space-y-6 text-[#A0AABF] leading-relaxed">
            <Section title="1. Service overview">
              ContentSnap provides done-for-you social media content creation. You pay, you complete an intake form, we deliver videos and images via a Google Drive link within the stated turnaround (72–96 hours depending on project size).
            </Section>

            <Section title="2. Payment & no refunds">
              Once payment is successfully received, the order is considered final. We <strong className="text-white">do not issue refunds</strong> for any reason, including but not limited to: change of mind, late submission of intake form details, failure to use the delivered content, dissatisfaction with creative direction, or business circumstances changing. By submitting payment you acknowledge this no-refund policy.
            </Section>

            <Section title="3. Revisions">
              Each order includes <strong className="text-white">one (1) round of revisions</strong>. Once we deliver your initial batch, you may request changes once. Any subsequent revisions or additional content requests are billable separately. Revision requests must be submitted within 7 days of initial delivery — after that the order is considered closed.
            </Section>

            <Section title="4. Intake form & cooperation">
              Timely, accurate intake information is required to begin production. If you do not submit the intake form, or if information provided is incomplete, the turnaround clock pauses until we receive what we need. Delays caused by missing or inaccurate information do not entitle you to a refund.
            </Section>

            <Section title="5. Monthly subscription">
              The $175/month Done For You Monthly Content Plan renews every 30 days from the initial payment date. You may cancel at any time by emailing contentsnapbrand@gmail.com or using the contact form. Cancellation takes effect at the end of your current billing cycle. <strong className="text-white">No partial refunds or prorated credits will be issued</strong> for unused time within a paid period.
            </Section>

            <Section title="6. Content ownership & usage">
              Upon delivery and full payment, you receive a non-exclusive license to use the delivered content for your business marketing (social media, website, ads). ContentSnap retains the right to use anonymized or watermarked versions of delivered content for portfolio and marketing purposes.
            </Section>

            <Section title="7. Limitations">
              ContentSnap is not liable for any business outcomes, performance metrics, advertising results, or financial returns associated with the delivered content. Our liability is strictly limited to the amount paid for the specific order in question.
            </Section>

            <Section title="8. Acceptable content">
              We reserve the right to decline or cancel orders that involve illegal, hateful, adult, discriminatory, or misleading content. In such cases, no refund will be issued — the order is simply terminated without delivery.
            </Section>

            <Section title="9. Acceptance">
              By completing checkout, submitting the intake form, or otherwise using our service, you affirm that you have read, understood, and agreed to these Terms of Service in full.
            </Section>

            <Section title="10. Contact">
              Questions about these terms? Email{" "}
              <a href="mailto:contentsnapbrand@gmail.com" className="text-[#3B9EFF] hover:underline">contentsnapbrand@gmail.com</a>.
            </Section>
          </div>

          <div className="mt-10 flex gap-3">
            <Link to="/offer/pack-99" className="btn-primary" data-testid="terms-cta-99">I Accept — Get $99.99 Pack</Link>
            <Link to="/privacy" className="btn-secondary" data-testid="terms-privacy-link">Privacy Policy</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

const Section = ({ title, children }) => (
  <div>
    <h2 className="font-display text-xl font-bold text-white">{title}</h2>
    <p className="mt-2">{children}</p>
  </div>
);
